module.exports = __webpack_public_path__ + "pivotaltracker.f7e600.svg";